import React from "react";
import { motion } from "framer-motion";
import { useLanguage } from "../contexts/LanguageContext";

const ITEMS = [1, 2, 3, 4, 5, 6, 7];

export const HowItWorks = () => {
  const { t } = useLanguage();

  return (
    <section id="how" className="relative py-24 md:py-32 px-5 md:px-10 lg:px-16" data-testid="how-section">
      <div className="max-w-[1440px] mx-auto">
        <div className="mb-14 md:mb-16 max-w-3xl">
          <div className="font-mono text-[10px] tracking-[0.22em] uppercase text-[#A9824A] mb-3">
            · 11 / Education
          </div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-black tracking-tighter text-[#F5F1EA] leading-[0.98]">
            {t("howTitle")}
          </h2>
          <p className="mt-5 text-[15px] text-[#E6E0D6]/80 leading-relaxed">{t("howSub")}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {ITEMS.map((n, i) => (
            <motion.div
              key={n}
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.06, ease: [0.22, 1, 0.36, 1] }}
              className="rounded-3xl border border-[#D8DCE2]/8 bg-[#15171c] p-7 hover:border-[#D7B56D]/30 transition-colors duration-300"
              data-testid={`how-card-${n}`}
            >
              <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#76D9E8] mb-3">
                {String(n).padStart(2, "0")} / {ITEMS.length}
              </div>
              <h3 className="font-display text-lg font-bold text-[#F5F1EA] mb-3 leading-tight">
                {t(`how${n}Title`)}
              </h3>
              <p className="text-[13px] text-[#D8DCE2]/75 leading-relaxed">{t(`how${n}Body`)}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
